import React, { useEffect, useRef } from 'react';
import Button from '@mercell/button-react';
import FieldError from '@mercell/field-error-react';
import { nl2br } from './nl2br';
export var DefaultCPVFieldComponent = function (_a) {
    var selectedCPVs = _a.selectedCPVs, setCPVPickerVisibility = _a.setCPVPickerVisibility, onChangeFieldValue = _a.onChangeFieldValue, showErrors = _a.showErrors, errors = _a.errors, isDisabled = _a.isDisabled, initialFieldValue = _a.initialFieldValue, name = _a.name, setSelectedCPVs = _a.setSelectedCPVs, allowToSelectOnlyOne = _a.allowToSelectOnlyOne;
    var selectedCPVsRef = useRef(selectedCPVs);
    useEffect(function () {
        if (JSON.stringify(selectedCPVs) !==
            JSON.stringify(selectedCPVsRef.current)) {
            onChangeFieldValue(selectedCPVs);
        }
    }, [onChangeFieldValue, selectedCPVs]);
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", null, selectedCPVs.map(function (code) { return (React.createElement("li", { key: code }, code)); })),
        React.createElement(Button, { scheme: "primary", onClick: function () { return setCPVPickerVisibility(true); }, disabled: isDisabled }, "Open CPV Picker"),
        showErrors && React.createElement(FieldError, null, nl2br(errors))));
};
